// The page's HTTP requests, shown as a fill in the notch's grip. Every fetch of the page and its applets goes through the
// wrapper here, so none of them has to report anything; what the browser loads by itself (images, frames) and the live
// channel are not counted. A browser cannot say how far along a request is, so the fill is made of what it does know: the
// requests of this burst finished out of those started, each still running creeping along so one long request still moves.
const SHOW_AFTER = 150; // ms a burst runs before it shows, or a quick request would twitch the grip
const CREEP = 2000; // ms in which a running request creeps half way
const MOST = 0.95; // as far as the fill goes until every request has finished
const HOLD = 250; // ms the full fill stays before it fades
const $fill = document.getElementById('notch-grip-fill');
let started = 0, finished = 0; // this burst's requests: from the first one started with none running
let since = 0; // when this burst began
let progress = 0; // never drawn going back, however many more requests join
let frame = 0;
let hold = 0;

function draw() {
  const elapsed = performance.now() - since;
  if (elapsed >= SHOW_AFTER) {
    const creep = 1 - 1 / (1 + elapsed / CREEP);
    progress = Math.max(progress, Math.min(MOST, (finished + (started - finished) * creep) / started));
    $fill.style.setProperty('--progress', progress);
    $fill.classList.add('busy');
  }
  frame = requestAnimationFrame(draw);
}
function begin() {
  if (started === finished) {
    started = finished = progress = 0;
    since = performance.now();
    clearTimeout(hold);
    if (!$fill.classList.contains('busy')) $fill.style.setProperty('--progress', 0); // unseen, so it never shrinks in view
    frame = requestAnimationFrame(draw);
  }
  started++;
}
function end() {
  if (++finished < started) return;
  cancelAnimationFrame(frame);
  if (!$fill.classList.contains('busy')) return;
  $fill.style.setProperty('--progress', 1);
  hold = setTimeout(() => $fill.classList.remove('busy'), HOLD);
}
// Finished when its body has arrived, read or not: a copy is read to the end and dropped, chunk by chunk, so a large
// download is not held twice and a caller that only looks at the status does not leave it running for ever.
async function drain(res) {
  try {
    const reader = res.clone().body?.getReader();
    if (reader) while (!(await reader.read()).done);
  } catch {}
  end();
}

// Event wiring, run first by client.js so that no request goes uncounted.
export function init() {
  const native = window.fetch.bind(window);
  window.fetch = (input, options) => {
    if (/^(blob|data):/.test(input?.url ?? String(input))) return native(input, options); // already in memory
    begin();
    return native(input, options).then((res) => { drain(res); return res; }, (e) => { end(); throw e; });
  };
}
